import { z } from "zod";

import { imageFormatSchema } from "api/schemas/imageCollectionApiSchema";

const editorViewerOwnerPermissionsSchema = z.enum(["editor", "owner", "viewer"]);

/*********************************************
        /topic/{topic_id}/access/email
*********************************************/

const topicUserInviteSchema = z.object({
  email: z.string(),
  permission: editorViewerOwnerPermissionsSchema.extract(["editor", "viewer"]),
});

const topicInvitationsSchema = z.object({
  shared_users: z.array(topicUserInviteSchema),
});

export const topicAccessEmailPostSchema = z.object({
  invitations: topicInvitationsSchema.optional(),
});

/*********************************************
    /topic/{topic_id}/access/email/{email}
*********************************************/

export const topicAccessPatchSchema = z.object({
  permission: editorViewerOwnerPermissionsSchema.extract(["editor", "viewer"]),
});

/*********************************************
    /topic/{topic_id}/access/invite_token
*********************************************/

export const topicAccessInvitePostSchema = z.object({
  permission: editorViewerOwnerPermissionsSchema.extract(["editor", "viewer"]),
});

export const topicAccessInviteResponseSchema = z.object({
  invite_token: z.string(),
});

/*********************************************
        /topic/{topic_id}/visibility
*********************************************/

export const topicVisibilityPatchSchema = z.object({
  visibility: z.enum(["private", "public"]),
});

/*********************************************
          /topic/{topic_id}/access
*********************************************/

export const userInfoAndAccessControlForTopicSchema = z.object({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  full_name: z.string(),
  email: z.string(),
  image_url: z.string().optional(),
  permission: editorViewerOwnerPermissionsSchema,
  pending: z.boolean(),
});

export const inviteeInfoAndAccessControlForTopicSchema = z.object({
  id: z.string().optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  full_name: z.string().optional(),
  email: z.string(),
  image_url: z.string().optional(),
  permission: editorViewerOwnerPermissionsSchema.extract(["editor", "viewer"]),
  pending: z.boolean(),
});

export const directTopicAccessControlGroupsSchema = z.object({
  owners: z.array(userInfoAndAccessControlForTopicSchema),
  editors: z.array(userInfoAndAccessControlForTopicSchema),
  viewers: z.array(userInfoAndAccessControlForTopicSchema),
  invitees: z.array(inviteeInfoAndAccessControlForTopicSchema),
});

/*********************************************
        /topic/access/{invite_token}
*********************************************/

export const topicAccessInviteTokenResponseSchema = z.object({
  topic_id: z.string(),
  topic_name: z.string(),
  topic_images: imageFormatSchema.optional(),
  topic_creator_name: z.string(),
  user_id: z.string(),
  permission: editorViewerOwnerPermissionsSchema.extract(["owner", "viewer"]),
});
